import React from "react";
import { DateTime } from "luxon";
import { CustomerTypes } from "constants/enums";
import { ClearLabel } from "components/controls";
import { FieldNames } from "./InvoiceFilters";

const FieldMappings = {
  [FieldNames.CustomerTypes]: "Customer Type",
  [FieldNames.DepartmentDisplay]: "Department",
  [FieldNames.InvoicedDateFrom]: "Invoiced Date From",
  [FieldNames.InvoicedDateTo]: "Invoiced Date To",
  [FieldNames.ContractManagerDisplay]: "Contract Manager",
  [FieldNames.ExportedDateFrom]: "Exported Date From",
  [FieldNames.ExportedDateTo]: "Exported Date To",
  [FieldNames.UnexportedOnly]: "Show Unexported Invoices",
};

const FormatDisplay = (item) => {
  let value = item.value;
  switch (item.label) {
    case FieldNames.CustomerTypes:
      value = item.value.map((x) => CustomerTypes[x]).join(", ");
      break;
    case FieldNames.InvoicedDateFrom:
    case FieldNames.InvoicedDateTo:
    case FieldNames.ExportedDateFrom:
    case FieldNames.ExportedDateTo:
      value = DateTime.fromISO(item.value).toFormat("dd MMM yyyy");
      break;
    case FieldNames.UnexportedOnly:
      return `${FieldMappings[item.label] || item.label}`;
  }

  return `${FieldMappings[item.label] || item.label}: ${value}`;
};

const InvoicesFilterDisplay = ({ filters, resetFilters }) => {
  const items = filters
    ? Object.keys(filters)
        .filter(
          (f) =>
            f !== FieldNames.Search &&
            f !== FieldNames.Department &&
            f !== FieldNames.ContractManager &&
            filters[f] != undefined &&
            filters[f] != null &&
            filters[f] != ""
        )
        .map((k) => {
          return {
            label: k,
            value: filters[k],
          };
        })
        .sort((a, b) => {
          if (
            (a.label == FieldNames.InvoicedDateFrom &&
              b.label == FieldNames.InvoicedDateTo) ||
            (a.label == FieldNames.ExportedDateFrom &&
              b.label == FieldNames.ExportedDateTo)
          ) {
            return -1;
          } else if (
            (b.label == FieldNames.InvoicedDateFrom &&
              a.label == FieldNames.InvoicedDateTo) ||
            (b.label == FieldNames.ExportedDateFrom &&
              a.label == FieldNames.ExportedDateTo)
          ) {
            return 1;
          }
          return 0;
        })
    : [];

  if (!items.length) return null;

  return (
    <div className="filter-display">
      {items.map((item) => (
        <div
          className="filter-display-item"
          key={item.label}
          title={FormatDisplay(item)}
        >
          {FormatDisplay(item)}
        </div>
      ))}
      <ClearLabel onClick={resetFilters} />
    </div>
  );
};

export default InvoicesFilterDisplay;
